export type BranchDisplaySource = {
    branchId?: string | number | null;
    branchName?: string | number | null;
    branchFullName?: string | number | null;
};

export const formatBranchDisplayLabel = (
    source: BranchDisplaySource | null | undefined,
    fallbackBranches?: Array<{ id: number; name: string }> | null,
): string => {
    if (!source) {
        return '- - -';
    }

    if (source.branchFullName != null && source.branchFullName !== '') {
        return String(source.branchFullName);
    }

    const branchId = source.branchId;
    const branchName = source.branchName != null ? String(source.branchName).trim() : '';

    if (branchId != null && branchId !== '' && branchName) {
        return `${branchId} ${branchName}`;
    }

    const branch = fallbackBranches?.find((element) => element?.id === branchId);
    if (branch) {
        return `${branch.id} ${branch.name}`;
    }

    if (branchId != null && branchId !== '') {
        return String(branchId);
    }

    return '- - -';
};
